module.exports = __webpack_public_path__ + "static/media/jane.00b48783.jpg";